import type { Mission } from '../missions.ts'

export const ntia: Mission = {
  id: "ntia",
  name: "National Telecommunications and Information Administration",
  short: "NTIA",
  call: "Connectivity",
  kind: "subagency",
  parent: "doc",
  url: "https://www.ntia.gov/",
  established: 1978,
  palette: {
    primary: "#33006d",
    secondary: "#000000",
    accent: "#e7d000",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:US-NationalTelecommunicationsAndInformationAdministration-Logo.svg",
  },
  motif: "bolt",
  mission: {
    text: "NTIA's programs and policymaking focus on securing U.S. dominance in next-generation technologies, promoting efficient use of spectrum to advance America’s national and economic security, ensuring universal broadband availability in America, enhancing public safety communications, conducting cutting-edge research to inform technology policy decisions, and ensuring that the internet remains an engine for free expression and American-led innovation.",
    url: "https://www.ntia.gov/page/about-ntia",
  },
  fact: {
    text: "NTIA as it exists today was created in 1978 by an executive order that moved federal telecommunications policy to the Commerce Department; the 1992 Telecommunications Authorization Act gave it statutory authority.",
    url: "https://www.ntia.gov/45-year-anniversary",
  },
  seal: {
    file: "public/seals/ntia.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-NationalTelecommunicationsAndInformationAdministration-Logo.svg",
  },
  identifier: {
    about: "https://www.ntia.gov/page/about-ntia",
    accessibility: "https://www.ntia.gov/page/about-ntias-web-site-accessibility-policy",
    foia: "https://www.ntia.gov/page/freedom-information-act-information",
    oig: "https://www.oig.doc.gov/",
    privacy: "https://www.ntia.gov/page/ntia-privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/ntia-fiber-utah.jpg",
        small: "/media/ntia-fiber-utah-sm.jpg",
        alt: "An orange fiber-optic cable marker post stands in open sagebrush range with snow-capped mountains on the horizon in rural Utah.",
        title: "Fiber-optic cable marker during a rural broadband build, Utah, February 29, 2024",
        creator: "James G. Pinsky, U.S. Department of Agriculture",
        source: "https://commons.wikimedia.org/wiki/File:Fiber-optic_cabling_is_installed_as_part_of_USDA_Rural_Development%E2%80%99s_work_in_rural_Utah_with_high-speed_internet_access_on_29_February_2024_-_17.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
